import { createSelector } from 'reselect';
import getActiveAuthorId from './getActiveAuthorId';
import getIdentities from './getIdentities';

export default createSelector(
  [getIdentities, getActiveAuthorId],
  (identities, activeAuthorId) => (
    identities.find(({ amazonAuthorId }) => (amazonAuthorId === activeAuthorId))
    || identities[0]
  ),
);
